import React, { useEffect, useState } from "react";
import {
	Row, Col, Card, CardBody, Input, Label, Button, Form, Alert, Badge, Table
} from "reactstrap";
import Loader from "common/loader";
import { post, get, put } from "../../helpers/api_helper";
import { DRIVER_WALLET_DETAILS } from "helpers/api_endpoints";
import Select from "react-select";
import { Trans } from "react-i18next";

const WalletDash = ({ userId = "" }) => {
	const [change, setChange] = useState(0);
	const [loading, setLoading] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [wallets, setWallets] = useState([]);
	const [status, setStatus] = useState('');

	useEffect(() => {
		post(DRIVER_WALLET_DETAILS, {userId})
			.then(response => {
				const data = response.data;
				setWallets(data);
			})
			.catch(() => setErrorMsg("Failed to load "));
		}, []);

		return (
			<Card>
				<CardBody>
					<Row>
						{errorMsg && <Alert color="danger">{errorMsg}</Alert>}
							<div className="table-responsive">
								<Table className="table table-striped table-bordered mb-0">
									<thead>
										<tr>
											<th>
												<Trans>Partner</Trans>
											</th>
											<th>
												<Trans>Partner Branch</Trans>
											</th>
											<th>
												<Trans>Balance</Trans>
											</th>
											<th>#</th>
										</tr>
									</thead>
									<tbody>
										{loading ? (
											<tr>
												<th colSpan={10} className="text-center">
													<Loader></Loader>
												</th>
											</tr>
										) : null}
										{wallets?.map((wallet, index) => (
											<tr key={index}>
												<td>{wallet.partner?.name}</td>
												<td><b>{wallet.partnerBranch?.name}</b></td>
												<td><b>{wallet.balance}</b></td>
											</tr>
										))}
									</tbody>
								</Table>
							</div>
					</Row>
				</CardBody>
			</Card>
	);
};

export default WalletDash;
